import React, { memo } from 'react';
import '../../../Common/Filters/Filters.css';
import MultipleSelect from '../../../Common/Filters/MultipleSelect';
import { useCensusFiltersContext } from './hooks/useCensusFiltersContext';

const CensusFilters = ({ className = '' }) => {
    const { filters, yearOptions, onFilterChange } = useCensusFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Ano do Censo"
                options={yearOptions}
                onChange={onFilterChange}
                name="year"
                defaultValue={filters.year}
                className="select-ano-dashboards"
            />
        </div>
    );
};

export default memo(CensusFilters);
